import React from "react"
import './App.css';

import Collection from "./collection"

function App() {
  return (
    <Collection />
  );
}

export default App;
